import { useMemo } from 'react'
import ConfirmationDialog from '../../../../../../CommonComponents/confirmation_dialog/ConfirmationDialog';
import useCustomSchedule from '../../../../../hooks/useCustomSchedule';

const ScheduleConfirmationModal = () => {
    const { scheduleConfirmationModal, setScheduleConfirmationModal, setCustomScheduleModalData, onDelete } = useCustomSchedule()
    const mode = useMemo(() => scheduleConfirmationModal?.mode, [scheduleConfirmationModal?.mode])
    const confirmText = useMemo(() => mode === 'delete' ? 'Delete' : 'Confirm', [mode])

    const handleConfirm = () => {
        if (mode === 'delete') {
            onDelete()
        } else {
            setCustomScheduleModalData(null)
            setScheduleConfirmationModal(null)
        }
    }

    if (!scheduleConfirmationModal?.open || !mode) return null
    return (
        <ConfirmationDialog
            type={mode}
            open={scheduleConfirmationModal?.open ? true : false}
            title={scheduleConfirmationModal?.message}
            description={scheduleConfirmationModal?.description}
            onCancel={() => setScheduleConfirmationModal(null)}
            onConfirm={() => handleConfirm()}
            confirm_button_text={confirmText}
            loading={scheduleConfirmationModal?.loading}
        />
    )
}

export default ScheduleConfirmationModal